{
  "name": "minimal",
  "displayName": "Minimal Clean",
  "description": "A quiet, warm minimal theme — Calibri throughout, sage-green ink on ivory neutrals, a large tracked-tight bold title, wide margins and hairline rules",
  "whenToUse": "Quiet documents where the type carries the tone: notes, briefs, drafts and internal papers that want warmth without decoration.",
  "version": "4.0.0",
  "colors": {
    "primary": "#2B302B",
    "secondary": "#4A5B4E",
    "accent": "#6E7F71",
    "text": "#3B3C38",
    "background": "#FFFFFF",
    "border": "#D8D3C8",
    "textPrimary": "#3B3C38",
    "textSecondary": "#5B5B54",
    "textMuted": "#75726A",
    "borderPrimary": "#D8D3C8",
    "borderSecondary": "#E9E6DE",
    "backgroundPrimary": "#FFFFFF",
    "backgroundSecondary": "#F1EFE9",
    "accent4": "#9AA69C",
    "accent5": "#C9CFC7",
    "accent6": "#B5AC9D"
  },
  "fonts": {
    "heading": { "family": "Calibri", "size": 21 },
    "body": { "family": "Calibri", "size": 10 },
    "mono": { "family": "Courier New", "size": 10 },
    "light": { "family": "Calibri", "size": 21 }
  },
  "page": {
    "size": "A4",
    "margins": {
      "top": 1700,
      "bottom": 1700,
      "left": 1700,
      "right": 1700,
      "header": 850,
      "footer": 850,
      "gutter": 0
    }
  },
  "styles": {
    "normal": {
      "font": "body",
      "color": "textPrimary",
      "lineSpacing": { "type": "multiple", "value": 1.35 },
      "alignment": "left",
      "spacing": { "after": 8 }
    },
    "title": {
      "font": "heading",
      "size": 34,
      "bold": true,
      "color": "primary",
      "alignment": "left",
      "lineSpacing": { "type": "multiple", "value": 1.0 },
      "characterSpacing": { "type": "condensed", "value": 20 },
      "spacing": { "before": 0, "after": 11 }
    },
    "subtitle": {
      "font": "body",
      "size": 13,
      "italic": false,
      "color": "textSecondary",
      "alignment": "left",
      "lineSpacing": { "type": "multiple", "value": 1.2 },
      "spacing": { "before": 0, "after": 22 }
    },
    "heading1": {
      "font": "heading",
      "size": 21,
      "bold": true,
      "color": "primary",
      "lineSpacing": { "type": "multiple", "value": 1.15 },
      "spacing": { "before": 30, "after": 10 },
      "keepNext": true,
      "alignment": "left"
    },
    "heading2": {
      "font": "heading",
      "size": 14.5,
      "bold": true,
      "color": "primary",
      "lineSpacing": { "type": "multiple", "value": 1.15 },
      "spacing": { "before": 22, "after": 8 },
      "keepNext": true,
      "alignment": "left"
    },
    "heading3": {
      "font": "heading",
      "size": 12,
      "bold": true,
      "color": "primary",
      "spacing": { "before": 16, "after": 6 },
      "keepNext": true,
      "alignment": "left"
    },
    "heading4": {
      "font": "body",
      "size": 10.5,
      "bold": true,
      "color": "primary",
      "spacing": { "before": 12, "after": 4 },
      "keepNext": true,
      "alignment": "left"
    },
    "heading5": {
      "font": "body",
      "size": 10.5,
      "bold": false,
      "italic": true,
      "color": "textSecondary",
      "spacing": { "before": 10, "after": 4 },
      "keepNext": true,
      "alignment": "left"
    },
    "heading6": {
      "font": "body",
      "size": 10,
      "bold": false,
      "color": "textMuted",
      "characterSpacing": { "type": "expanded", "value": 20 },
      "spacing": { "before": 10, "after": 4 },
      "keepNext": true,
      "alignment": "left"
    },
    "TOC1": {
      "font": "body",
      "size": 10.5,
      "bold": true,
      "color": "textPrimary",
      "spacing": { "before": 4, "after": 3 },
      "tabStops": [{ "type": "right", "position": 8506, "leader": "none" }]
    },
    "TOC2": {
      "font": "body",
      "size": 10.5,
      "color": "textSecondary",
      "indent": { "left": 240 },
      "spacing": { "after": 2 },
      "tabStops": [{ "type": "right", "position": 8506, "leader": "none" }]
    },
    "TOC3": {
      "font": "body",
      "size": 10,
      "color": "textMuted",
      "indent": { "left": 480 },
      "spacing": { "after": 2 },
      "tabStops": [{ "type": "right", "position": 8506, "leader": "none" }]
    }
  },
  "componentDefaults": {
    "table": {
      "borderColor": "#D8D3C8",
      "borderSize": 0.5,
      "hideBorders": { "left": true, "right": true, "insideVertical": true },
      "cellDefaults": {
        "padding": { "top": 3, "bottom": 3 }
      },
      "headerCellDefaults": {
        "font": { "bold": true },
        "color": "#2B302B",
        "borderColor": { "bottom": "#2B302B" },
        "borderSize": { "bottom": 1 }
      }
    },
    "list": {
      "format": "bullet",
      "bullet": "–",
      "spacing": { "item": 2 }
    },
    "image": {
      "alignment": "left"
    },
    "statistic": {
      "alignment": "left"
    },
    "section": {
      "pageBreak": false
    }
  }
}
